import Masonry from "masonry-layout"
document.querySelectorAll('.masonry-layout').forEach(el => {
    const masonry = new Masonry(el, {
        itemSelector: '.masonry-item',
        percentPosition: true,
        columnWidth: '.masonry-sizer',
        gutter: 10
    });
})
